import axios from "axios";

export const postRequest = async (arg) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/${arg.subLink}`,
      arg.data
    );
    return response.data; // Axios automatically parses the JSON response
  } catch (e) {
    return e;
  }
};
